////    CORE    ////
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

////    COMPONENTS    ////
import { ModalInfoComponent } from './modal-info.component'

////    MODULES    ////
import { MaterialImporterModule } from 'src/app/shared/material-importer/material-importer.module'
import { FlexLayoutModule } from '@angular/flex-layout'

@NgModule({
  declarations: [ModalInfoComponent],
  imports: [CommonModule, MaterialImporterModule, FlexLayoutModule],
  exports: [ModalInfoComponent],
})
export class ModalInfoModule {}
